import Vue from 'vue'
import Router from 'vue-router'
import { requireAuth, homepageRedirect, noAuth } from '@/services/auth'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router({
  // This mode removes trailing /#/ sign from URLs
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'DashboardPage',
      beforeEnter: homepageRedirect,
      component: () => import(/* webpackChunkName: "mainpage" */ '../views/DashboardPage.vue'),
    },
    {
      path: '/login',
      name: 'LoginPage',
      beforeEnter: noAuth,
      component: () => import(/* webpackChunkName: "mainpage" */ '../views/LoginPage.vue'),
    },
    {
      path: '/company-detail/:id?',
      name: 'CompanyDetail',
      component: () => import(/* webpackChunkName: "subpage" */ '../views/CompanyDetailPage.vue'),
      beforeEnter: requireAuth,
    },
    {
      path: '/companies',
      name: 'CompaniesPage',
      component: () => import(/* webpackChunkName: "mainpage" */ '../views/CompaniesPage.vue'),
      beforeEnter: requireAuth,
    },
    {
      path: '/posts',
      name: 'PostsPage',
      component: () => import(/* webpackChunkName: "mainpage" */ '../views/PostsPage.vue'),
      beforeEnter: requireAuth,
    },
    {
      path: '/user/profile',
      name: 'ProfilePage',
      component: () => import(/* webpackChunkName: "mainpage" */ '../views/ProfilePage.vue'),
      beforeEnter: requireAuth,
    },

    {
      path: '/password/reset/confirm/:uid/:token',
      name: 'ResetPasswordPage',
      component: () => import(/* webpackChunkName: "subpage" */ '../views/ResetPasswordPage.vue'),
    },
    {
      path: '/password/reset/link',
      name: 'RequestPasswordResetPage',
      component: () =>
        import(/* webpackChunkName: "subpage" */ '../views/RequestPasswordResetPage.vue'),
    },
  ],
})
